//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LoginForm from "~/themes/fiskarsMoominDefault/components/components/organisms/LoginForm/LoginForm.vue";
import SfModal from "~/themes/fiskarsMoominDefault/components/components/molecules/SfModal/SfModal.vue";
export default {
  name: "LoginFormModal",
  components: {
    SfModal,
    LoginForm,
  },
  props: {
    texts: Object,
    visible: Boolean
  },
}
